// src/firebase.ts
import { initializeApp } from 'firebase/app';
// Importuj potrzebne moduły Firebase w miarę dodawania funkcjonalności
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { createFirebasePublicConfig } from './config/firebaseConfig';
// import { getAnalytics } from "firebase/analytics";

// Konfiguracja Firebase odczytywana ze zmiennych środowiskowych
const firebaseConfig = createFirebasePublicConfig(process.env);

// Debug logging for Firebase configuration
console.log('Firebase Config Check:', {
  hasApiKey: !!firebaseConfig.apiKey,
  hasAuthDomain: !!firebaseConfig.authDomain,
  hasProjectId: !!firebaseConfig.projectId,
  hasStorageBucket: !!firebaseConfig.storageBucket,
  hasMessagingSenderId: !!firebaseConfig.messagingSenderId,
  hasAppId: !!firebaseConfig.appId,
});

// Inicjalizacja Firebase
const app = initializeApp(firebaseConfig);

// Inicjalizacja i eksport usług Firebase
const firestore = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
// Dla Functions często trzeba podać region, np. 'europe-central2' (Warszawa)
// Upewnij się, że region jest zgodny z tym, który wybierzesz w konsoli Firebase
const functions = getFunctions(app, 'europe-central2'); // Przykładowy region dla Warszawy
// const analytics = firebaseConfig.measurementId ? getAnalytics(app) : undefined;

console.log('Firebase initialized with valid public web config');

export { app, firestore, auth, storage, functions };
// export { analytics };
